import React, {useCallback, useContext, useEffect, useRef, useState} from "react"
import RefreshTimer from "../../util/RefreshTimer";
import {ThinClientOverviewContext} from "./context/ThinClientOverviewContext";
import Row from "@meridian/components/row";
import {
    convertTableJsonToAsset,
    getAPIGatewayPostRequest,
    getCurrentDate,
    getNodeId,
    getRefreshInterval, logOperationalMetric
} from "../../util/Util";
import Column from "@amzn/meridian/column";
import {FormattedMessage, injectIntl} from "react-intl";
import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    BLUE_COLOR,
    ENDPOINT_DEPLOY_THIN_CLIENT,
    HEALTH_OK,
    LOADING_FAILED,
    ONLINE_OK,
    ORANGE_COLOR,
    PRIMARY,
    SBL_ASSET_TYPE,
    SECONDARY,
    THIN_CLIENT_ASSET_TYPE
} from "../../util/Constants";
import Button from "@amzn/meridian/button";
import Menu, {MenuItem} from "@amzn/meridian/menu"
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Text from "@amzn/meridian/text"
import Icon from "@amzn/meridian/icon";
import editTokens from "@amzn/meridian-tokens/base/icon/edit"
import Input from "@amzn/meridian/input";
import Box from "@amzn/meridian/box";
import {getAssets, setAssetStatus, updateAsset} from "../../resources/AssetResource";
import {
    extractThinClientDeviceList,
    metricProcessName,
    postUpdatedRemarkToDevice
} from "./network/ThinClientOverviewNetworkAPI";
import Tooltip from "@amzn/meridian/tooltip";
import Loader from "../../loader/Loader";
import chevronDownLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-down-large";
import DeleteSingleDeviceModal from "../../commonui/DeleteSingleDeviceModal";
import DisableMonitoringModal from "./modal/DisableMonitoringModal";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import Alert from "@amzn/meridian/alert";

const ThinClientOverview = ({intl}) => {

    const {viewModel, dispatch} = useContext(ThinClientOverviewContext);
    const [openActionsMenu, setOpenActionsMenu] = useState({});
    const [openAddModal, setOpenAddModal] = useState(false)
    const actionButtonRefs = useRef([]);
    const [mac, setMac] = useState("")
    const [remark, setRemark] = useState([]);
    const [reload, setReload] = useState(false);
    const tableEndRef = useRef(null)

    const onClickActionsButton = useCallback((index) => {
        let _open = {...openActionsMenu};
        _open[index] = true;
        setOpenActionsMenu(_open);
    }, []);
    const onCloseActions = useCallback((index) => {
        let _open = {...openActionsMenu};
        _open[index] = false;
        setOpenActionsMenu(_open)
    }, []);

    useEffect(() => {
        getData()
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData();
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        actionButtonRefs.current = actionButtonRefs.current.slice(0, viewModel.thinClientDeviceInformation.length);
        setRemark(sortedDeviceList.map((value) => {
            return {value: value.remark, close: true}
        }))
    }, [viewModel.thinClientDeviceInformation]);

    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }
    const sortedDeviceList = Object.values(viewModel.thinClientDeviceInformation);
    sortedDeviceList && sortedDeviceList.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    const scrollToBottom = () => {
        tableEndRef.current.scrollIntoView({behavior: "smooth"})
    }
    const onClickDisableMonitoring = (mac) => {
        setMac(mac)
        setOpenAddModal(true)
    }
    const onClickEnableMonitoring = (startTime, reason, mac) => {
        const stateValues = {
            "startTime": startTime,
            "endTime": getCurrentDate(),
            "reason": reason
        }
        addData(stateValues, mac);
        setReload(true);
        getData();
    }
    const onClickDeploy = async (mac, usecase) => {
        try {
            const deploymentInput = {
                nodeId: getNodeId(),
                macAddress: mac,
                thinClientUsecase: usecase
            };
            const startTime = Date.now();
            const args = getAPIGatewayPostRequest(deploymentInput, ENDPOINT_DEPLOY_THIN_CLIENT);
            getAPIGatewayDataFromParent(args).then(response => {
                if (response.status === 200) {
                    logOperationalMetric(startTime, metricProcessName, "deployThinClient", true);
                } else {
                    logOperationalMetric(startTime, metricProcessName, "deployThinClient", false);
                }
            });
        } catch (e) {
            console.log(`Mac Address ${mac} deployment API failed due to `, e);
            return null;
        }
        setReload(true);
        getData();
    }

    const addData = (stateValues, mac) => {
        dispatch({type: 'ADD_DEVICE_DATA', data: {dispatcher: dispatch, stateValues: stateValues, mac: mac}})
    }

    const onClickToggleUsecase = useCallback(async (device, usecase_to_make) => {
        // function to make that tc primary and rest all secondary and vice versa basis on usecase_to_make
        const newAssetNewUsecase = convertTableJsonToAsset({
            ...device,
            primary_secondary: usecase_to_make
        }, THIN_CLIENT_ASSET_TYPE, ACTIVE);
        const responseSetAssetStatus = await setAssetStatus(newAssetNewUsecase.assetDetails.assetLabel, ACTIVE);
        if (responseSetAssetStatus.status !== 200) {
            alert(ALERT_ASSET_STATUS_MESSAGE);
        } else if (responseSetAssetStatus.status === 200) {
            const responseUpdateAsset = await updateAsset(newAssetNewUsecase);
            if (responseUpdateAsset.status !== 200) {
                alert(ALERT_UPDATE_ASSET_MESSAGE);
            }
        }
        setReload(true);
        getData();
        if (usecase_to_make === PRIMARY) {
            const getResponse = await getAssets(getNodeId(), THIN_CLIENT_ASSET_TYPE);
            if (getResponse.status === 200) {
                const deviceList = Object.values(extractThinClientDeviceList(getResponse).thinClientDeviceInformation);
                deviceList.map(async (otherDevice) => {
                    if (otherDevice.mac !== device.mac && otherDevice.usecase === SBL_ASSET_TYPE) {
                        const newAssetOriginalUsecase = convertTableJsonToAsset({
                            ...otherDevice,
                            primary_secondary: device.primary_secondary
                        }, THIN_CLIENT_ASSET_TYPE, ACTIVE);
                        const responseSetAssetStatus = await setAssetStatus(newAssetOriginalUsecase.assetDetails.assetLabel, ACTIVE);
                        if (responseSetAssetStatus.status !== 200) {
                            alert(ALERT_ASSET_STATUS_MESSAGE);
                        } else if (responseSetAssetStatus.status === 200) {
                            const responseUpdateAsset = await updateAsset(newAssetOriginalUsecase);
                            if (responseUpdateAsset.status !== 200) {
                                alert(ALERT_UPDATE_ASSET_MESSAGE);
                            }
                        }
                        setReload(true);
                        getData();
                    }
                })
            }
        }
    }, [reload]);

    const handleKeyDown = (index, row, event) => {
        if (event.key === "Enter") {
            onClickConfirmRemark(index, row);
        }
    }
    const onClickConfirmRemark = (index, row) => {
        // function to send the updated remark to post request in db
        const temp = [...remark];
        temp[index] = {...temp[index], close: true};
        setRemark(temp)
        postUpdatedRemarkToDevice(row, remark[index].value).then(r => {
            setReload(true);
            getData();
        })
    }
    const onClickEditRemark = (index) => {
        const temp = [...remark];
        temp[index] = {...temp[index], close: false};
        setRemark(temp)
    }
    const getData = () => {
        setOpenAddModal(false)
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }
    const handleInputChange = (index, value) => {
        const temp = [...remark];
        temp[index] = {...temp[index], value: value};
        setRemark(temp)
    }

    if (viewModel.loadingOverview) {
        return (<Loader/>)
    } else {
        return (
            <Row widths="100%"
                 alignmentVertical="top"
                 spacingInset="none none large none">
                <Column>
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <RefreshTimer deps={[viewModel]}/>
                        <Box></Box>
                        <Tooltip position="top" title={intl.formatMessage({
                            id: 'tooltip.scrolltobottom',
                            defaultMessage: 'Scroll to bottom!'
                        })}>
                            <Button onClick={scrollToBottom}
                                    type="secondary"
                                    size="small">
                                <Icon tokens={chevronDownLargeTokens}/>
                            </Button>
                        </Tooltip>
                    </Row>
                    {sortedDeviceList.length === 0 ?
                        <Alert
                            type="informational"
                            size="small"
                        >
                            <FormattedMessage id="alert.device"
                                              defaultMessage="No device present for this station."/>
                        </Alert> :
                    <Table
                        headerRows={1}
                        spacing="small"
                        sortColumn={viewModel.sortPref.column}
                        sortDirection={viewModel.sortPref.direction}
                        onSort={onSort}
                        showDividers={true}
                        showStripes={true}>
                        <TableRow highlightOnHover={false}>
                            <TableCell sortColumn="mac">
                                <FormattedMessage id="device.mac_ip" defaultMessage="MAC/IP"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="device.vlan" defaultMessage="VLAN"/>
                            </TableCell>
                            <TableCell sortColumn="usecase">
                                <FormattedMessage id="device.usecase" defaultMessage="Use Case"/>
                            </TableCell>
                            <TableCell sortColumn="connection">
                                <Tooltip position="top" title={intl.formatMessage({
                                    id: 'status.tooltip',
                                    defaultMessage: 'Online means device is connected to Internet. It can be Healthy or ' +
                                        'Unhealthy based on Deep Health Check. Offline signifies not connected to internet hence, no health status.'
                                })}>
                                    <FormattedMessage id="device.status" defaultMessage="Status"/>
                                </Tooltip>
                            </TableCell>
                            <TableCell sortColumn="swstatus">
                                <FormattedMessage id="device.swstatus" defaultMessage="Software Status"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="device.remark" defaultMessage="Remark"/>
                            </TableCell>
                            <TableCell>
                                <FormattedMessage id="device.action" defaultMessage="Action"/>
                            </TableCell>
                        </TableRow>
                        {sortedDeviceList.map((device, index) => (
                            <TableRow key={device.name}
                                      highlightOnHover={true}>
                                <TableCell> <b>{device.mac}</b>
                                    <br></br>
                                    {device.ip}
                                </TableCell>
                                <TableCell>{device.vlan}</TableCell>
                                <TableCell>
                                    {device.usecase}
                                    {device.usecase === SBL_ASSET_TYPE && device.primary_secondary === PRIMARY &&
                                        <Text type="b200">
                                            <div style={{color: BLUE_COLOR}}>{device.primary_secondary}</div>
                                        </Text>}
                                </TableCell>
                                <TableCell>
                                    {device.connection ? device.connection === ONLINE_OK ?
                                        <p style={{color: device.healthstatus === HEALTH_OK ? BLUE_COLOR : ORANGE_COLOR}}>
                                            <b>{device.healthstatus}</b>
                                        </p> :
                                        <p style={{color: ORANGE_COLOR}}>
                                            <b>{device.connection}</b>
                                        </p> : <FormattedMessage id="loading.text" defaultMessage="Loading..."/>}
                                </TableCell>
                                <TableCell>
                                    {device.swstatus ? device.swstatus === LOADING_FAILED ?
                                            <p style={{color: ORANGE_COLOR}}>
                                                <b>{device.swstatus}</b>
                                            </p> : <b>{device.swstatus}</b> :
                                        <FormattedMessage id="loading.text" defaultMessage="Loading..."/>}
                                </TableCell>
                                <TableCell width="400px">
                                    <Row>
                                        {(remark[index] && remark[index].close === true) && (remark[index].value === "" ?
                                            <Text truncate="true">{device.remark} </Text> :
                                            <Text truncate="true"
                                                  value={remark[index].value}>{remark[index].value} </Text>)}
                                        {remark[index] && (remark[index].close === false) ?
                                            (<Row>
                                                <Input
                                                    onChange={(value) => handleInputChange(index, value)}
                                                    value={remark[index].value}
                                                    placeholder="Enter remark"
                                                    size="small"
                                                    autoFill="true"
                                                    focus="true"
                                                    resize="none"
                                                    onKeyDown={(event) => handleKeyDown(index, device, event)}
                                                    rows={1}/>
                                                <Button
                                                    onClick={() => onClickConfirmRemark(index, device)}
                                                    size="small">
                                                    <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                                                </Button>
                                            </Row>) :
                                            <Button type="link"
                                                    onClick={() => onClickEditRemark(index)}
                                                    size="small">
                                                <Icon tokens={editTokens}/>
                                            </Button>}
                                    </Row>
                                </TableCell>
                                <TableCell>
                                    <Text type="b300">
                                        <Button ref={el => actionButtonRefs.current[index] = el}
                                                type="icon"
                                                size="medium"
                                                onClick={() => onClickActionsButton(index)}
                                                aria-controls="my-menu"
                                                aria-haspopup="menu"
                                                aria-expanded="false">
                                            ...
                                        </Button>
                                        <Menu anchorNode={actionButtonRefs.current[index]}
                                              id="my-menu"
                                              open={openActionsMenu[index] ? openActionsMenu[index] : false}
                                              position="left"
                                              onClose={() => onCloseActions(index)}>
                                            <MenuItem onClick={() => onClickDeploy(device.mac, device.usecase)}>
                                                <FormattedMessage id="actions.deploy" defaultMessage="Deploy"/>
                                            </MenuItem>
                                            {(new Date(getCurrentDate()) < new Date(device.startTime) || new Date(getCurrentDate()) > new Date(device.endTime)) &&
                                                <MenuItem onClick={() => onClickDisableMonitoring(device.mac)}>
                                                    <FormattedMessage id="actions.monitoring_disable"
                                                                      defaultMessage="Disable Monitoring"/>
                                                </MenuItem>}
                                            {(new Date(getCurrentDate()) >= new Date(device.startTime) && new Date(getCurrentDate()) <= new Date(device.endTime)) &&
                                                <MenuItem
                                                    onClick={() => onClickEnableMonitoring(device.startTime, device.reason, device.mac)}>
                                                    <FormattedMessage id="actions.monitoring_enable"
                                                                      defaultMessage="Enable Monitoring"/>
                                                </MenuItem>}
                                            {device.usecase === SBL_ASSET_TYPE && device.primary_secondary === SECONDARY &&
                                                <MenuItem onClick={() => onClickToggleUsecase(device, PRIMARY)}>
                                                    <FormattedMessage id="actions.primary"
                                                                      defaultMessage="Make Primary Use Case"/>
                                                </MenuItem>}
                                        </Menu>
                                        {openAddModal && <DisableMonitoringModal mac={mac} state={openAddModal}
                                                                                 onStateChange={setOpenAddModal}/>}
                                    </Text>
                                </TableCell>
                            </TableRow>
                        ))}
                    </Table>}
                    <Row width="100%" widths={["fill", "100"]}>
                        <Box></Box>
                        <DeleteSingleDeviceModal macAddressArray={viewModel.macAddressArray} dispatch={dispatch}/>
                    </Row>
                    <div ref={tableEndRef}/>
                </Column>
            </Row>
        );
    }
}

export default injectIntl(ThinClientOverview)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/ThinClientOverview.js